export default __webpack_public_path__ + "static/media/consumption_energy_icon.2fb6004a.svg";